module.exports = __webpack_public_path__ + "static/media/prize-rare-1.8016e02c.webp";